import posthog from "posthog-js";

import { Env } from "../constants/env";

export const AnalyticsEvents = {
  OTP_CONFIRMED: "otp_confirmed",
  ROUTE_CHANGED: "route_changed",
  BUTTON_CLICKED: "button_clicked",

  MANUFACTURER_LOGIN: "manufacturer_login",
  MANUFACTURER_LOGIN_FAILED: "manufacturer_login_failed",
  EMPLOYEE_ADDED: "employee_added",
  EMPLOYEE_UPDATED: "employee_updated",
  STRAIN_ADDED: "strain_added",
  STRAIN_UPDATED: "strain_updated",
  COA_TOKENIZED: "coa_tokenized",
  BATCH_TOKENIZED: "batch_tokenized",
  ANNOUNCEMENT_SCHEDULED: "announcement_scheduled",
  API_CONNECTIONS_UPDATED: "api_connections_updated",
  BATCH_DETAILS_PAGE_VIEWED: "batch_details_page_viewed",
  CONSUMER_FEEDBACK_VIEWED: "consumer_feedback_viewed",
  BANK_DETAILS_UPDATED: "bank_details_updated",
  ACCOUNT_SETTINGS_UPDATED: "account_settings_updated",
  API_CONNECTION_FAILED: "api_connection_failed",
  HELP_CENTER_OPENED: "help_center_opened",
  RETURNED_FROM_HELP_CENTER: "returned_from_help_center",
  HELP_CENTER_AUTO_LOGIN_FAILED: "help_center_auto_login_failed",
  SUBSCRIPTION_PURCHASED: "subscription_purchased",
  CART_CHECKOUT_SUCCESS: "cart_checkout_success",
};

export function capturePosthogEvent(
  eventName: string,
  properties?: Record<string, unknown>,
) {
  if (!Env.POSTHOG_KEY) return;
  if (Env.MODE !== "pre-prod" && Env.MODE !== "production") return;

  posthog.capture(eventName, {
    timestamp: new Date().toISOString(),
    ...properties,
  });
}
